


















import { Component, Mixins } from "vue-property-decorator";
import Assets from "wallet/components/wallet/Assets.vue";
import BalanceCard from "wallet/components/wallet/BalanceCard.vue";
import AssetsSearch from "wallet/components/wallet/AssetsSearch.vue";
import TopAssets from "wallet/components/wallet/TopAssets/Index.vue";
import WalletAction from "wallet/components/wallet/WalletActions.vue";
import mixins from "@/mixins";

@Component({
  components: {
    Assets,
    BalanceCard,
    AssetsSearch,
    TopAssets,
    WalletAction
  }
})
class Wallet extends Mixins(mixins.page, mixins.processOrders) {
  get title() {
    return this.$t("common.assets") as string;
  }

  handleLogin() {
    this.$common.utils.helper.requestLogin(this);
  }

  handleToDetail(id) {
    this.$helper.toFusionPath(this, "wallet", {
      name: "snapshots-id",
      params: { id }
    });
  }

  mounted() {
    this.$store.dispatch("wallet/mixin/loadAssets");
  }
}
export default Wallet;
